export class DeleteSectorByIdUseCase{
  constructor(repository,sectorHasSoilrepository,sectorHasFarmrepository) {
    this.repository = repository
    this.sectorHasSoilRepository= sectorHasSoilrepository
    this.sectorHasFarmRepository= sectorHasFarmrepository
  }
  async execute(ID_SECTOR){

    const data= await this.repository.showBySectorId(ID_SECTOR)

    if(data[0].length){
      await this.sectorHasFarmRepository.deleteByIdSector(data[0][0].ID)
      await this.sectorHasSoilRepository.deleteByIdSector(data[0][0].ID)
    }

    const resp = await this.repository.deleteById(ID_SECTOR)


    return resp
  }
}
